// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuetify from 'vuetify'
import Vuefire from 'vuefire'
import VueClipboard from 'vue-clipboard2'
import VueI18n from 'vue-i18n'
import VueCookie from 'vue-cookie'
import VueAnalytics from 'vue-analytics'

import ProgressDialog from '@/components/utils/ProgressDialog'
import ConfirmDialog from '@/components/utils/ConfirmDialog'
import Toast from '@/components/utils/Toast'
import FuncTypeIcons from '@/components/utils/FuncTypeIcons'

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'chartjs-plugin-annotation'

import router from './router'

Vue.prototype.$appName = APP_NAME;
Vue.prototype.$fb = firebase.initializeApp(FIREBASE_ACCESS);
Vue.prototype.$auth = firebase.auth();
Vue.prototype.$db = firebase.database();
Vue.prototype.$FuncTypeIcons = FuncTypeIcons;

Vue.use(Vuetify, {
  theme: THEME_COLOR
})
Vue.use(Vuefire)
Vue.use(VueClipboard)
Vue.use(VueI18n)
Vue.use(VueCookie)

if (GOOGLE_ANALYTICS_ID && process.env.NODE_ENV == 'production') {
  Vue.use(VueAnalytics, {
    id: GOOGLE_ANALYTICS_ID,
    router,
    autoTracking: {
      pageviewOnLoad: false
    }
  })
}

Vue.use(ProgressDialog)
Vue.use(ConfirmDialog)
Vue.use(Toast)

Vue.config.productionTip = false

router.beforeEach(function(to, from, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      if (user) {
        if (to.name === 'Login') {
          next({
            path: to.query.redirect || '/'
          });
        } else {
          next();
        }
      } else {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        });
      }
    });
  } else {
    next();
  }
});

const i18n = new VueI18n({
  locale: VueCookie.get('lang') || DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  messages: {
    'en': require('./lang/en'),
    'zh': require('./lang/zh'),
    'jp': require('./lang/jp')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: {
    App
  },
  created() {
    document.title = this.$appName;
  },
  watch: {
    '$route'(to, from) {
      this.searchGateway = null;
      this.searchKeyword = null;
      this.searchFuncType = null;
    }
  },
  data() {
    return {
      userAuth: null,
      userDevice: null,
      userMacInfo: null,
      userTargetName: null,
      userCamera: null,
      userFace: null,
      userScene: null,
      userMacro: null,
      userMacroSchedule: null,
      userContact: null,
      userSchedule: null,
      userKanban: null,
      userTracker: null,
      searchGateway: null,
      searchKeyword: null,
      searchFuncType: null
    }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js